/**
 * Square icon-sized control for compact toolbars; label must be catalog-backed for **`aria-label`**.
 *
 * @param ariaLabel - Accessible name (resolved **`Translate`** string).
 * @param glyph - Visible single-character or symbol (may be non-translated punctuation).
 * @param options - Disabled flag.
 * @returns **`button[type=button]`** with **`qz-icon-btn`** classes.
 */
export function createIconButton(
  ariaLabel: string,
  glyph: string,
  options?: Readonly<{ disabled?: boolean }>,
): HTMLButtonElement {
  const btn = document.createElement("button");
  btn.type = "button";
  btn.disabled = Boolean(options?.disabled);
  btn.setAttribute("aria-label", ariaLabel);
  btn.className = "qz-icon-btn";

  const span = document.createElement("span");
  span.className = "qz-icon-btn__glyph";
  span.setAttribute("aria-hidden", "true");
  span.textContent = glyph;
  btn.appendChild(span);

  return btn;
}
